/**
 * better-mega-drawer.js
 * Controller for the Olipop-style mobile drawer:
 *   - Shop / Learn segmented tab toggle
 *   - Accordion rows (single-open within a panel by default)
 *
 * Tap-driven; no hover. Self-contained custom element.
 */
class MegaDrawer extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-drawer-tab]')];
    this.panels = [...this.querySelectorAll('[data-drawer-panel]')];
    this.accordions = [...this.querySelectorAll('[data-drawer-acc]')];

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab.dataset.drawerTab));
    });

    this.accordions.forEach((trigger) => {
      trigger.addEventListener('click', () => this.toggleAccordion(trigger));
    });
  }

  selectTab(name) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.drawerTab === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    });
    this.panels.forEach((panel) => {
      const active = panel.dataset.drawerPanel === name;
      panel.classList.toggle('is-active', active);
      panel.toggleAttribute('hidden', !active);
    });
  }

  toggleAccordion(trigger) {
    const body = trigger.nextElementSibling;
    const willOpen = trigger.getAttribute('aria-expanded') !== 'true';

    // Single-open within the same accordion list (the parent <ul>).
    const list = trigger.closest('ul');
    if (willOpen && list) {
      list.querySelectorAll('[data-drawer-acc]').forEach((other) => {
        if (other !== trigger) this.setAccordion(other, false);
      });
    }
    this.setAccordion(trigger, willOpen);
  }

  setAccordion(trigger, open) {
    const body = trigger.nextElementSibling;
    trigger.setAttribute('aria-expanded', String(open));
    if (body) body.toggleAttribute('hidden', !open);
  }
}

if (!customElements.get('mega-drawer')) {
  customElements.define('mega-drawer', MegaDrawer);
}
